import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pic",
  "use": "icon-pic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pic\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8,11a2,2,0,1,1,2-2A2,2,0,0,1,8,11Zm12,6.82L14,12.2l-7,7H20Zm0-2.61V5.2H4v14l10-10Zm-18,5V4.2a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1v16a1,1,0,0,1-1,1H3A1,1,0,0,1,2,20.2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol